module.exports = __webpack_public_path__ + "img/pic15.62b551a5.jpg";